import Typography from 'typography'

/*const typography = new Typography({
  googleFonts: [{
    name: 'Roboto',
    styles: ['400', '400i'],
  }],
})*/
const typography = new Typography({
  baseFontSize: '14px',
  baseLineHeight: 1.666,
  headerFontFamily: ['AIG Futura', 'sans-serif'],
  bodyFontFamily: ['Neutra Text', 'sans-serif'],
  // See below for the full list of options.
})

export default typography


// WEBPACK FOOTER //
// ./src/lib/typography.js